/*普查动态-政策文件 by szc 2023/06/13/
<template>
  <div class="policyPaper">
    <div class="mian">
      <div class="titleGroup">
        <Card style="width: 100%; height: 100%">
          <!-- <div class="title">
            <Icon type="ios-folder-open" />
            相关文件
          </div> -->
          <Menu ref="menus" class="menus" @on-select="itemSelect" :active-name="activeName">
            <MenuItem
              v-for="(item, index) in regulationsList"
              class="menuItem"
              :name="item.value"
              :key="item.id"
            >
              {{ item.title }}
            </MenuItem>
          </Menu>
        </Card>
      </div>
      <div class="tableform">
        <Row>
          <Input
            id="search"
            search
            v-model="searchForm.title"
            @on-search="search"
            @on-enter="search"
            placeholder="按关键字搜索"
          />
        </Row>
        <Row class="right">
          <div class="tableData" v-if="tableData.length > 0">
            <Table :columns="columnsDta" :data="tableData" size="large">
              <template #data="{ row, index }">
                <div style="border-right: 2px solid #d9d9d9">
                  <h2 class="colH2">{{ row.data.day }}</h2>
                  <span class="colSpan">{{ row.data.year }}</span>
                </div>
              </template>
              <template #title="{ row, index }" @click="policyPaperDetails(row)">
                <h2 class="colH2" @click="policyPaperDetails(row)">{{ row.title.title }}</h2>
                <!-- <div
                  class="colSpan"
                  @click="policyPaperDetails(row)"
                  v-html="row.title.content"
                ></div> -->
                <div class="colSpan" @click="policyPaperDetails(row)">
                  {{ row.title.content }}
                </div>
              </template>
              <template #download="{ row, index }">
                <Button class="colBut" @click="handlDownload(row)">下载附件</Button>
              </template>
            </Table>
          </div>
          <div class="page" v-if="tableData.length > 0">
            <Page
              ref="Page"
              :current="searchForm.pageNumber"
              :total="total"
              :page-size="searchForm.pageSize"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
              show-total
              show-elevator
            >
              <template> 共{{ total }}条，每页10条 </template>
            </Page>
          </div>
          <div class="nodata" v-else>
            <img src="../../../static/image/noData.png" />
            <span>很抱歉，此页面暂无内容</span>
          </div>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import { findRegulationsPage, downLoadBatch } from '@/api/Recommended';
import { getDictDataByType } from '@/api/index';
// 引入Cookies
import Cookies from 'js-cookie';
export default {
  name: 'policyPaper',
  components: {},
  data() {
    return {
      loading: false,
      currentTitle: '',
      data: [],
      searchForm: {
        pageNumber: 1, // 当前页数
        releaseStatus: 1,
        pageSize: 10, // 页面大小
        sort: 'createTime', // 默认排序字段
        order: 'desc', // 默认排序方式
        title: '',
        typePrimary: 0,
        subtype: '',
      },
      total: 0,
      searchKeys: '',
      regulationsList: [],
      columnsDta: [
        {
          title: '日期',
          key: 'data',
          // type: 'index',
          align: 'center',
          width: 150,
          slot: 'data',
        },
        {
          title: '标题',
          key: 'title',
          tooltip: true,
          align: 'center',
          className: 'titleClass',
          slot: 'title',
        },
        {
          title: '下载',
          key: 'download',
          align: 'center',
          slot: 'download',
          className: 'downloadClass',
          width: 230,
        },
      ],
      tableData: [],
      isInit: true,
      spinShow: false,
      xbootConfig: '',
      activeName: null,
      token: '', // 当前登录token
    };
  },
  props: {},
  mounted() {},
  computed: {},
  created() {
    this.token = Cookies.get('accessToken');
    let policyPaper = this.$store.state.app.censusActivity.policyPaper;
    if (policyPaper) {
      this.searchForm.subtype = policyPaper.subtype;
      this.searchForm.title = policyPaper.title;
    }
    this.getDictData();
  },
  beforeDestroy() {
    this.$store.commit('setPolicyPaper', this.searchForm);
  },
  watch: {},
  methods: {
    /**
     * 查询接口
     */
    getDataList() {
      findRegulationsPage(this.searchForm).then((res) => {
        if (res.result.records) {
          let result = [];
          res.result.records.forEach((i) => {
            result.push({
              id: i.id,
              data: {
                year: i.createTime && i.createTime.slice(0, 4),
                day: i.createTime && i.createTime.slice(5, 10),
              },
              title: {
                title: i.title,
                content: i.noHtmlContext,
              },
              download: i.fileList,
            });
          });
          this.tableData.splice(0, this.tableData.length, ...result);
          this.total = res.result.total;
        }
      });
    },

    /**
     * 标签接口
     */
    getDictData() {
      getDictDataByType('policyFile').then((res) => {
        if (res.result) {
          res.result.unshift({
            id: '000000',
            sortOrder: 0,
            status: 0,
            title: '全部文件',
            value: '',
          });
          this.regulationsList = res.result;
          if (this.regulationsList.length > 0) {
            this.getDataList();
            this.$nextTick(() => {
              this.activeName = this.searchForm.subtype || '';
            });
          }
        }
      });
    },

    policyPaperDetails(row) {
      this.$router.push({
        path: `/policyPaperDetails`,
        query: {
          id: row.id,
        },
      });
    },

    itemSelect(value) {
      if (this.searchForm.subtype == value) {
        return;
      }
      this.searchForm.subtype = value;
      this.getDataList();
    },
    search() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },

    handlDownload(file) {
      // 判断是否有token
      if (!this.token) {
        // 跳转到登录页
        this.$router.push('/login');
        return;
      }
      file.id &&
        downLoadBatch(file.id).then((res) => {
          const blob = res;
          var url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', file.title.title + '.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.policyPaper {
  width: 100%;
  height: calc(~'100vh - 15rem');
  background: #e5f1fd;
  overflow-y: scroll;
  overflow-x: hidden;
  .mian {
    display: flex;
    padding-top: 5rem;
    padding-left: 17rem;

    .titleGroup {
      color: #333333;
      // height: 92.2rem;
      height: 70vh;
      background: #f2f7fd;
      border: 0;
      background-clip: padding-box;
      // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      .title {
        font-size: 2rem;
        color: blue;
        margin-bottom: 1rem;
      }
      .ivu-card {
        box-shadow: none;
      }
      .menus {
        .menuItem {
          font-size: 1.6rem;
          font-family: yahei;
          color: #424242;
          font-weight: 400;
          line-height: 2.6rem;
          border-bottom: 1px solid #eaeaea;
        }
      }
    }

    .tableform {
      margin-left: 11rem;
      padding-top: 5rem;
      width: 123rem;
      height: (100%-40rem);
      background: #f2f7fd;
      #search /deep/.ivu-input {
        margin-left: 5rem;
        padding: 0 2rem;
        width: 50rem;
        height: 5rem;
        font-size: 1.8rem !important;
        box-shadow: none;
        font-family: yahei;
        font-weight: 400;
        color: #777;
        line-height: 2rem;
        border-radius: 3.2rem;
        opacity: 1;
        background: #dce8ff;
      }
      .right {
        position: relative;
        .tableData {
          margin-top: 2rem;
          width: 150rem;
          .colH2 {
            margin-bottom: 1.2rem;
            font-size: 1.6rem;
            font-family: yahei;
            font-weight: 600;
            color: #333333;
            line-height: 2.6rem;
          }
          div.colSpan {
            cursor: pointer;
          }
          h2.colH2 {
            cursor: pointer;
          }
          .colSpan {
            font-size: 1.4rem;
            font-family: yahei;
            font-weight: 400;
            color: #424242;
            line-height: 1.9rem;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .colBut {
            margin-right: 5rem;
            height: 4.5rem;
            width: 14.5rem;
            font-size: 1.6rem;
            font-family: yahei;
            font-weight: 400;
            color: #005aff;
            line-height: 2rem;
            padding: 1rem 2rem;
            background: #dce8ff;
            padding: 0.9rem 3rem;
            border: none;
          }
        }
        .page {
          display: inline-block;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          padding: 2rem 0 4rem;
          background: #f2f7fd;
          font-size: 1.4rem;
          font-family: yahei;
          font-weight: 400;
          color: #555555;
          line-height: 2.3rem;
        }

        div.nodata {
          display: flex;
          padding-bottom: 2rem;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          width: 130rem;
          img {
            width: 50rem;
            height: 50rem;
          }
          span {
            margin-right: 1.5rem;
            font-size: 1.8rem;
            font-family: yahei;
            font-weight: 400;
            color: #333333;
            line-height: 2.1rem;
          }
        }
      }
    }
  }
}

/deep/.ivu-table td.titleClass {
  padding: 1rem 2.5rem;
  text-align: left;
}

// 去掉表头
/deep/.ivu-table-header {
  display: none;
}

// 修改表格背景颜色
/deep/.ivu-table td,
/deep/.ivu-table th,
/deep/.ivu-table {
  // background: #e5f1fd;
  background: #f2f7fd;
}

// 表格数据增加内边距和下划线
/deep/.ivu-table td {
  padding: 5rem 0;
  border-bottom: 2px solid rgba(217, 217, 217, 0.76);
}
// /deep/.ivu-table td:last-child {
//   padding: 5rem 2rem;
//   border-bottom: 2px solid rgba(217, 217, 217, 0.76);
// }
// 去掉表格最后一组数据下划线
/deep/.ivu-table tr:last-child {
  td {
    border: none;
  }
}
// 去掉表格下划线
/deep/.ivu-table:before {
  display: none;
}

//表格增加高度和滚动条
// /deep/.ivu-table-overflowY {
//   overflow-y: scroll;
//   height: 60rem !important;
// }

//去掉竖线
//去掉选择时的竖线
/deep/.ivu-menu-vertical.ivu-menu-light:after,
/deep/.ivu-menu-item-active::after {
  display: none !important;
}

//修改选择的样式
/deep/.ivu-menu-item-active {
  color: #fff !important;
  background: linear-gradient(90deg, #0055f0 0%, rgba(19, 83, 200, 0) 100%) !important;
}

/deep/.ivu-card-body {
  padding: 0;
}

/deep/.ivu-card,
/deep/.ivu-menu-light {
  background: #f2f7fd;
}

/deep/.ivu-menu {
  z-index: 1;
  width: 24rem !important;
  min-width: 120px !important;
}

//修改分页样式
/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value,
/deep/.ivu-select-dropdown-list .ivu-select-item {
  font-size: 20px !important;
  font-family: yahei;
  font-weight: 400;
  color: #000000;
}
/deep/.ivu-select-dropdown-list .ivu-select-item:hover {
  color: #005aff;
}

// 分页箭头大小
/deep/.ivu-page-prev a,
/deep/.ivu-page-next a {
  font-size: 20px;
  color: #dde1ea;
}

/deep/.ivu-page {
  display: flex;
  font-size: 20px;
  font-family: yahei;
  font-weight: 400;
  color: #000000;
  line-height: 23px;
}

/deep/.ivu-page-options-elevator,
/deep/.ivu-page-options-elevator input {
  font-size: 20px;
  font-family: yahei;
  font-weight: 400;
  color: #333333;
  line-height: 23px;
}

/deep/.ivu-input-search-icon {
  left: 50rem;
  font-size: 3rem;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/view/censusActivity/policyPaper.vue